import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { CountriesComponent }      from './countries.component';
import { CountriesService }        from './countries.service';
import { CountriesStates }         from './countries.states';
import { ImportsModule }           from '../imports/imports.module';
import { NewCountryTypeComponent } from './countries.new-country-type.component';
import { NewStateTypeComponent }   from './countries.new-state-type.component';
import { SharedModule }            from '../shared/shared.module';
import { TableModule }             from '../table/table.module';

@NgModule({
  declarations: [
    CountriesComponent,
    NewCountryTypeComponent,
    NewStateTypeComponent
  ],
  entryComponents: [
    CountriesComponent,
    NewCountryTypeComponent,
    NewStateTypeComponent
  ],
  imports: [
    ImportsModule,
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: CountriesStates })
  ],
  providers: [
    CountriesService
  ]
})
export class CountriesModule {}
